<div class="row dsp-login-row">
  <div class="columns dsp-login-column">
    <div class="dsp-login-header">
      <div class="dsp-login-welcome">Welcome to the</div>
      <div class="dsp-login-title">Investor Portal</div>
      <hr class="dsp-login-divider">
    </div>
    <div class="dsp-login-form">
      <form [formGroup]="loginForm" (keyup.enter)="onLogin()">
        <mercer-login [displayForgotPasswordLink]="true">
        </mercer-login>
      </form>
    </div>
    <div class="dsp-login-footer">
      <!-- <span class="dsp-login-help-link">
        <a (click)="forgotPassword()">Forgot Password</a>
      </span>
      <br>
      <br> -->
      <span class="dsp-login-help-link">
        <a (click)="onContactUs()">Contact Us</a> for assistance logging in

      </span>
    </div>
  </div>
</div>
<atlas-modal [disableClose]="false" #contactUs [headerRef]="contactUsHeader" [contentRef]="contactUsContent"
  [showDialogActions]="false" [size]="modalSize">
</atlas-modal>
<ng-template #contactUsHeader>
  <h4>Contact Information</h4>
</ng-template>
<ng-template #contactUsContent>
  <dsp-contact-us [showTitle]="false">
  </dsp-contact-us>
</ng-template>

<atlas-modal [size]="modalSize" [disableClose]="true" #redirectModal [headerRef]="redirectModalheader"
  [contentRef]="redirectModalcontent" [showDialogActions]="false">
</atlas-modal>
<ng-template #redirectModalheader>
  <h4>Important Notice: Our Portal URL has Changed</h4>
</ng-template>
<ng-template #redirectModalcontent>
  <div class="redirect-modal-content ">
    <p>Mercer has officially transitioned to Marsh.
      To ensure seamless access to your account and reporting, please update your bookmarks to our new official portal
      address:</p>

    <p>
      <a [href]="newUrl" rel="noopener noreferrer">{{ newUrl }}</a>
    </p>
    <p>You can continue logging in using your existing credentials.
      If you have any questions or need assistance accessing your account, please contact our support team.</p>
  </div>
</ng-template>